import moment from 'moment'
import { RechartDataObject } from './chartModel'

/* extends rechart data to display the winter to summer time switch area in the chart */
export const getRechartDataWithDstSwitchArea = (rechartDataArray: RechartDataObject[], isSummerToWinterSwitch: boolean): RechartDataObject[] => {
  const dstHourData = rechartDataArray?.filter(d => moment(d.ts as number)?.isDST())?.slice(-4) || []
  /* need to add extra point to the right to have full hour displayed */
  dstHourData?.push({
    ts: moment(dstHourData[dstHourData.length - 1]?.ts as number)
      .add(15, 'minutes')
      .valueOf(),
  })
  const rechartDataWithDstSwitchArea = rechartDataArray?.map(d => {
    const matchingDst = dstHourData?.find(dst => moment(dst.ts as number).isSame(moment(d.ts as number)))
    /* the Area that is being rendered is connected to the right Y axis, which is a percentage value from 0 to 100. Thus, 100 means the area will span from bottom all the way to top */
    const fullHeight = 100

    if (matchingDst && isSummerToWinterSwitch) {
      return { ...d, winterToSummerTimeSwitchArea: fullHeight }
    }
    return d
  })

  return rechartDataWithDstSwitchArea
}
